// extracted by mini-css-extract-plugin
export default {"wrap":"vacationsScheduleSubordinates_wrap__e2IkS","vacations__panel":"vacationsScheduleSubordinates_vacations__panel__UtQMY","buttons":"vacationsScheduleSubordinates_buttons__iyzQq"};